window.app = window.app || {};

window.app.activitiesList = {
  api: {
    content: 'https://public-dot-blazepod-apps-85c6f.uc.r.appspot.com/public/v1/contents'
  },
  data: [],
  lastUpdated: null,
  cookieName: '',
  createdByConfig: [],
  el: {
    section: document.querySelector('.mt-activities-list'),
    content: document.querySelector('.mt-activities-list__content'),
    loadMoreWrapper: document.querySelector('.mt-activities-list__action'),
    loadMore: document.querySelector('.mt-activities-list__load-more'),
    modal: {
      el: document.querySelector('.mt-modal--activity'),
      wrapper: document.querySelector('.mt-activity-info'),
      wrapperTop: document.querySelector('.mt-activity-info-top'),
      title: document.querySelector('.mt-activity-info__title'),
      authorName: document.querySelector('.mt-activity-info__author-name span:nth-child(1)'),
      authorSubtitle: document.querySelector('.mt-activity-info__author-name span:nth-child(2)'),
      authorImage: document.querySelector('.mt-activity-info__author-image'),
      fields: document.querySelector('.mt-activity-info__list--fields'),
      goals: document.querySelector('.mt-activity-info__list--goals'),
      setupPlayers: document.querySelector('.mt-activity-info__setup-item[data-type="players"]'),
      setupPods: document.querySelector('.mt-activity-info__setup-item[data-type="pods"]'),
      setupDuration: document.querySelector('.mt-activity-info__setup-item[data-type="duration"]'),
      gallery: document.querySelector('.mt-activity-info__gallery'),
      gallerySwiper: document.querySelector('.mt-activity-gallery'),
      galleryWrapper: document.querySelector('.mt-activity-gallery .swiper-wrapper'),
      shareButton: document.querySelector('.mt-activity-info__action.mt-activity__action-share'),
      saveButton: document.querySelector('.mt-activity-info__action.mt-activity__action-save')
    }
  },

  fetchActivites: async function () {
    const _this = this;
    const customSort = (a, b) => {
      const getIndex = name => window.activitiesOrder.indexOf(name.trim());
      const aIndex = getIndex(a.name);
      const bIndex = getIndex(b.name);
      return aIndex === bIndex ? 0 : aIndex === -1 ? 1 : bIndex === -1 ? -1 : aIndex - bIndex;
    };

    try {
      let data = await fetch(_this.api.content);
      data = await data.json();
      data = data.filter(item => item.name.includes(_this.el.section.dataset.activitiesQuery) || item.description.includes(_this.el.section.dataset.activitiesQuery));
      window.activitiesOrder && (data = data.sort(customSort));
      data = data.filter(i => i.creator === 'BlazePod');
      _this.data = data;
      
      window.sessionStorage.setItem(_this.cookieName, JSON.stringify(_this.data));
      window.sessionStorage.setItem(`${_this.cookieName}-ts`, new Date().getTime());
    } catch (e) {
      console.log("Error (cannot to fetch activities)", e);
    }
  },

  handleize: function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  },

  decodeEntities: function (str) {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  },

  escapeHtml: function (str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  },

  safeText: function (str) {
    return app.activitiesList.escapeHtml(app.activitiesList.decodeEntities(str));
  },

  render: function () {
    const _this = this;
    const defaultAvatar = window.activitesCreatorsAvatar ? window.activitesCreatorsAvatar : '';
    let contentHtml = '';

    if (_this.data.length === 0) return;

    // Update items per page
    let itemsPerPage = Number(_this.el.content.dataset.page);
    let itemsPerLoad = Number(_this.el.content.dataset.loadMore);
    const breakpointsPerPage = [
      { min: 550, max: 992, correction: 1 },
      { min: 993, max: 1179, correction: 1 },
      { min: 1180, max: 1360, correction: -1 }
    ];
    const matchingBreakpoint = breakpointsPerPage.find(({ min, max }) => window.innerWidth >= min && window.innerWidth < max);
    if (matchingBreakpoint) {
      itemsPerPage += matchingBreakpoint.correction;
      itemsPerLoad += matchingBreakpoint.correction;
      _this.el.content.dataset.page = itemsPerPage;
      _this.el.content.dataset.loadMore = itemsPerLoad;
    }

    // Update creators (config)
    _this.createdByConfig = [
      { title: 'BlazePod Activities', includes: ['BlazePod'] },
      { title: 'Community Activities', includes: [...new Set(_this.data.filter(item => item.creator !== 'BlazePod').map(item => item.creator))] }
    ];

    // Activities list
    _this.data.forEach(({ cover, creator, app_user_id, fields, goals, media, settings, name, share_link }, i) => {
      // Creator details
      let creatorObj = activitiesCreators.find(cr => cr.app_id === app_user_id) || (activitiesCreators.find(cr => cr.name === creator) || { name: creator, subtitle: '', image: defaultAvatar });
      (creatorObj.name !== creator) && (creatorObj.name = creator);
      creatorObj.image.includes('no-image') && (creatorObj.image = defaultAvatar);

      const item = document.createElement('div');
      item.classList = (i < itemsPerPage) ? 'mt-activity' : 'mt-activity hidden';
      item.dataset.id = i;
      _this.data[i].id = i;

      // Media (Gallery)
      const itemMedia = document.createElement('div');
      itemMedia.classList = 'mt-activity__media';
      if (cover) {
        const coverImg = document.createElement('img');
        coverImg.src = cover;
        coverImg.alt = name;
        coverImg.loading = 'lazy';
        itemMedia.appendChild(coverImg);
      }

      const itemVideo = media.filter(m => m.type === 'video');
      if (itemVideo.length > 0) {
        const itemMediaVideo = document.createElement('video');
        itemMediaVideo.setAttribute('data-src', itemVideo[0].url);
        itemMediaVideo.setAttribute('playsinline', '');
        itemMediaVideo.setAttribute('muted', '');
        itemMediaVideo.setAttribute('loop', '');
        itemMediaVideo.setAttribute('controlsList', 'nofullscreen nodownload noremoteplayback');
        itemMedia.appendChild(itemMediaVideo);
      }

      // Main content
      const itemContent = document.createElement('div');
      itemContent.classList = 'mt-activity__content';

      // Actions
      const itemActions = document.createElement('div');
      itemActions.classList = 'mt-activity__actions';

      // Title
      const itemTitle = document.createElement('p');
      itemTitle.classList = 'mt-activity__title';
      itemTitle.textContent = _this.decodeEntities(name);

      // Fields
      const itemFields = document.createElement('p');
      itemFields.classList = 'mt-activity__fields';
      itemFields.textContent = _this.decodeEntities(fields.join(' • '));

      // Goals
      const itemGoals = document.createElement('p');
      itemGoals.classList = 'mt-activity__goals';
      itemGoals.textContent = _this.decodeEntities(goals.join(' • '));

      // Info button
      const itemInfoButton = document.createElement('button');
      itemInfoButton.classList = 'mt-activity__info-button';
      itemInfoButton.type = 'button';

      // Action: Author
      const itemActionAuthor = document.createElement('div');
      itemActionAuthor.classList = 'mt-activity__action mt-activity__action-author';
      itemActionAuthor.dataset.appId = creatorObj.app_id || creator;
      itemActionAuthor.dataset.type = creatorObj.app_id ? 'id' : 'name';
      itemActionAuthor.dataset.title = creator;
      const authorImg = document.createElement('img');
      authorImg.src = creatorObj.image;
      authorImg.alt = creator;
      itemActionAuthor.appendChild(authorImg);
      itemActions.appendChild(itemActionAuthor);
         
      // Action: Share
      if (share_link !== null) {
        const itemActionShare = document.createElement('a');
        itemActionShare.classList = 'mt-activity__action mt-activity__action-share';
        itemActionShare.href = share_link;
        itemActions.appendChild(itemActionShare);
      }

      // Action: Save
      if (share_link !== null) {
        const itemActionSave = document.createElement('a');
        itemActionSave.classList = 'mt-activity__action mt-activity__action-save';
        itemActionSave.href = share_link;
        itemActions.appendChild(itemActionSave);
      }

      // Info
      const itemInfo = document.createElement('div');
      itemInfo.classList = 'mt-activity__info';
      const s = _this.safeText;
      itemInfo.innerHTML = `<div class="mt-activity__author">
          <div class="mt-activity__author-image"><img src="${creatorObj.image}" alt="${s(creator)}"></div>
          <p class="mt-activity__author-name"><span>${s(creator)}</span><span>${s(creatorObj ? creatorObj.subtitle : '')}</span></p>
        </div>`;

      // Build activity card
      itemMedia.appendChild(itemActions);
      itemContent.appendChild(itemTitle);
      itemContent.appendChild(itemFields);
      itemContent.appendChild(itemGoals);
      item.appendChild(itemMedia);
      item.appendChild(itemContent);

      contentHtml += item.outerHTML;
    });

    // No results
    const noResults = document.createElement('div');
    noResults.classList = 'mt-activities-list__no-results';
    noResults.innerHTML = `<p>No matches found for selected filters</p>`;
    contentHtml += noResults.outerHTML;

    _this.el.content.innerHTML = contentHtml;

    _this.createEvents();
    _this.updateVariables.activityTitle();
    _this.loadMore.init();
  },

  createEvents: function () {
    const _this = this;
    const items = document.querySelectorAll('.mt-activity');
    const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
    const updateItemWidth = () => {
      const item = document.querySelector('.mt-activity:not(.hidden)');
      if (!item) return;
      _this.el.section.style.setProperty('--activity-width', item.offsetWidth + 'px');
    };
    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        const item = entry.target;
        const itemVideo = item.querySelector('.mt-activity__media video');
        if (itemVideo && entry.intersectionRatio > 0) {
          if (itemVideo.getAttribute('data-src') !== null) {
            itemVideo.setAttribute('src', itemVideo.getAttribute('data-src'));
            itemVideo.setAttribute('preload', 'auto');
            itemVideo.removeAttribute('data-src');
            itemVideo.load();
          }
        }
        if (window.innerWidth <= 768 && itemVideo.getAttribute('src') !== '' && entry.intersectionRatio > 0.2) {
          item.classList.add('mt-activity--video-visible');
          itemVideo.play();
          setTimeout(() => isVideoPlaying(itemVideo) ? itemVideo.removeAttribute('controls') : itemVideo.setAttribute('controls', true), 500);
        }
        if (itemVideo && itemVideo.getAttribute('src') !== '' && entry.intersectionRatio <= 0.7) {
          item.classList.remove('mt-activity--video-visible');
          itemVideo.pause();
        }
      });
    };
    const observer = new IntersectionObserver(observerCallback, {
      root: null,
      rootMargin: "0px",
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    });

    // Items
    items.forEach((item, i) => {
      // Item media (video)
      const itemVideo = item.querySelector('.mt-activity__media video');
      if (itemVideo) {
        observer.observe(item);
        item.addEventListener('mouseenter', () => itemVideo.play());
        item.addEventListener('mouseleave', () => itemVideo.pause());
        itemVideo.addEventListener('play', () => itemVideo.removeAttribute('controls'));

        // Load first 4 videos
        if (i < 4 && itemVideo.getAttribute('data-src') !== null) {
          itemVideo.setAttribute('src', itemVideo.getAttribute('data-src'));
          itemVideo.removeAttribute('data-src');
          itemVideo.load();
        }
      }

      // Share button
      const shareButton = item.querySelector('.mt-activity__action-share');
      shareButton && shareButton.addEventListener('click', e => {
        e.preventDefault();
        if (navigator.clipboard) {
          navigator.clipboard.writeText(shareButton.href);
          const tooltip = shareButton.querySelector('.tooltip');
          tooltip && tooltip.remove();
          const el = document.createElement('div');
          el.classList.add('tooltip');
          el.innerText = "Copied to clipboard!";
          shareButton.appendChild(el);
          setTimeout(() => el.classList.add('active'), 1);
          setTimeout(() => el.classList.remove('active'), 2000);
          setTimeout(() => el.remove(), 2300);
        }
      });

      // Item x Modal
      item.addEventListener('click', e => {
        if (e.target.classList.contains('mt-activity__action')) return;

        e.preventDefault();

        const itemData = _this.data[Number(item.dataset.id)];
        const defaultAvatar = window.activitesCreatorsAvatar ? window.activitesCreatorsAvatar : '';
        let creatorObj = window.activitiesCreators.find(cr => cr.app_id === itemData.app_user_id) || (activitiesCreators.find(cr => cr.name === itemData.creator) || { name: itemData.creator, subtitle: '', image: defaultAvatar });
        (creatorObj.name !== itemData.creator) && (creatorObj.name = itemData.creator);
        creatorObj.image.includes('no-image') && (creatorObj.image = defaultAvatar);

        if (itemData && _this.el.modal.el) {
          // Gallery
          let galleryHtml = '';
          itemData.media.forEach((media, i) => {
            if (itemData.creator !== 'BlazePod' && itemData.media.length > 1 && i === 0) return;
            if (media.type == 'video') {
              galleryHtml += `<div class="swiper-slide">
                <figure class="mt-activity-gallery__item mt-activity-gallery__item--video">
                  <video src="${_this.escapeHtml(media.url)}" class="mt-activity-gallery__video" playsinline autoplay loop></video>
                </figure>
              </div>`;
            } else {
              galleryHtml += `<div class="swiper-slide">
                <figure class="mt-activity-gallery__item mt-activity-gallery__item--image">
                  <img src="${media.url}" class="mt-activity-gallery__image" alt="">
                </figure>
              </div>`;
            }
          });

          // Fields
          let fieldsHtml = '';
          itemData.fields.forEach(field => (fieldsHtml += `<li class="mt-activity-info__list-item">${field}</li>`));

          // Goals
          let goalsHtml = '';
          itemData.goals.forEach(goal => (goalsHtml += `<li class="mt-activity-info__list-item">${goal}</li>`));

          // Setup (Players, Pods, Duration)
          if (_this.el.modal.setupPlayers) {
            if (itemData.settings.players) {
              _this.el.modal.setupPlayers.querySelector('strong').innerHTML = itemData.settings.players;
              _this.el.modal.setupPlayers.classList.remove('hidden');
            } else {
              _this.el.modal.setupPlayers.classList.add('hidden');
            }
          }
          if (_this.el.modal.setupPods) {
            if (itemData.settings.pods) {
              _this.el.modal.setupPods.querySelector('strong').innerHTML = itemData.settings.pods;
              _this.el.modal.setupPods.classList.remove('hidden');
            } else {
              _this.el.modal.setupPods.classList.add('hidden');
            }
          }
          if (_this.el.modal.setupDuration) {
            if (itemData.settings.duration) {
              _this.el.modal.setupDuration.querySelector('strong').innerHTML = `${itemData.settings.duration / 1000}s`;
              _this.el.modal.setupDuration.classList.remove('hidden');
            } else {
              _this.el.modal.setupDuration.classList.add('hidden');
            }
          }

          // Save & Share buttons
          _this.el.modal.shareButton.classList.add('hidden');
          _this.el.modal.saveButton.classList.add('hidden');
          if (itemData.share_link != '') {
            _this.el.modal.shareButton.href = itemData.share_link;
            _this.el.modal.saveButton.href = itemData.share_link;
            _this.el.modal.shareButton.classList.remove('hidden');
            _this.el.modal.saveButton.classList.remove('hidden');
          }

          _this.modalSlider && _this.modalSlider.destroy(true, true);
          _this.el.modal.title.innerHTML = itemData.name;
          _this.el.modal.authorImage.innerHTML = `<img src="${creatorObj.image}" alt="${itemData.creator}">`;
          _this.el.modal.authorName.innerHTML = itemData.creator;
          _this.el.modal.authorSubtitle.innerHTML = creatorObj ? creatorObj.subtitle : '';
          _this.el.modal.fields.innerHTML = fieldsHtml;
          _this.el.modal.goals.innerHTML = goalsHtml;
          _this.el.modal.galleryWrapper.innerHTML = galleryHtml;

          _this.modalSlider = new Swiper(_this.el.modal.gallerySwiper, {
            slidesPerView: 1,
            spaceBetween: 0,
            direction: 'horizontal',
            speed: 800,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true
            }
          });

          app.modal.open(_this.el.modal.el);
        }
      });
    });

    // Modal
    _this.el.modal.shareButton && _this.el.modal.shareButton.addEventListener('click', e => {
      e.preventDefault();
      if (navigator.clipboard) {
        navigator.clipboard.writeText(_this.el.modal.shareButton.href);
        const tooltip = _this.el.modal.shareButton.querySelector('.tooltip');
        tooltip && tooltip.remove();
        const el = document.createElement('div');
        el.classList.add('tooltip');
        el.innerText = "Copied to clipboard!";
        _this.el.modal.shareButton.appendChild(el);
        setTimeout(() => el.classList.add('active'), 1);
        setTimeout(() => el.classList.remove('active'), 2000);
        setTimeout(() => el.remove(), 2300);
      }
    });

    if (_this.el.modal.wrapper && _this.el.modal.wrapperTop) {
      _this.el.modal.wrapper.addEventListener('scroll', () => {
        _this.el.modal.wrapperTop.classList.toggle('mt-activity-info-top--sticky', _this.el.modal.wrapper.scrollTop > 0);
      });
    }

    // Items 
    updateItemWidth();
    _this.updateVariables.activityTitle();
    window.addEventListener('resize', () => {
      _this.updateVariables.activityTitle();
      updateItemWidth();
    });
  },

  updateVariables: {
    activityTitle: () => {
      const itemTitles = document.querySelectorAll('.mt-activity:not(.hidden) .mt-activity__title');
      itemTitles.forEach(title => {
        const item = title.closest('.mt-activity');
        item.style.setProperty('--title-height', `${title.offsetHeight}px`);
      });
    }
  },

  loadMore: {
    update: function () {
      const _this = app.activitiesList;
      const hiddenActivities = document.querySelectorAll('.mt-activity.hidden');

      if (hiddenActivities.length === 0) {
        _this.el.loadMoreWrapper.classList.add('hidden');
      } else {
        _this.el.loadMoreWrapper.classList.remove('hidden');
      }
    },

    init: function () {
      const _this = this;
      const itemsPerPage = Number(app.activitiesList.el.content.dataset.loadMore);
      let hiddenActivities = document.querySelectorAll('.mt-activity.hidden');

      app.activitiesList.el.loadMore.addEventListener('click', e => {
        e.preventDefault();

        hiddenActivities = document.querySelectorAll('.mt-activity.hidden');
        if (hiddenActivities.length > 0) {
          for (let i = 0; i < itemsPerPage; i++) {
            hiddenActivities[i] && hiddenActivities[i].classList.remove('hidden');
          }
          hiddenActivities = document.querySelectorAll('.mt-activity.hidden');
          _this.update();
          window.dispatchEvent(new Event('resize'));
        }
      });

      _this.update();
    }
  },

  init: async function () {
    const _this = this;
    const now = new Date().getTime();
    let actualData = true;

    // Update cookies
    _this.cookieName = `bp-activities-${_this.el.section.dataset.activitiesPage}`;
    _this.data = window.sessionStorage.getItem(_this.cookieName) ? JSON.parse(window.sessionStorage.getItem(_this.cookieName)) : [],
    _this.lastUpdated = window.sessionStorage.getItem(`${_this.cookieName}-ts`) ? Number(window.sessionStorage.getItem(`${_this.cookieName}-ts`)) : null,
    (_this.data.length === 0) && (actualData = false);
    if (now >= (_this.lastUpdated + 3600000)) {
      actualData = false;
      _this.data = [];
      _this.filtersData = [];
      _this.lastUpdated = null;
    };
    (!actualData) && await _this.fetchActivites();
    _this.render();
  }
}
window.app.activitiesList.init();